module.exports = __webpack_public_path__ + "img/graduate.43f05d3c.png";